// extracted by mini-css-extract-plugin
export var dropdownContainer = "_5h-5";
export var imageContainer = "_5h-4";
export var metricsGrid = "_5h-2";
export var productDetailContainer = "_5h-1";
export var productListContainer = "_5h-0";
export var subscriberTableContainer = "_5h-3";